/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

import { Subject, filter, takeUntil } from 'rxjs';

import { CoreMenuItem } from '../../../../../types';
import { CoreMenuService } from '../../services/core-menu.service';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[xbaht-core-menu-vertical-collapsible]',
  templateUrl: './collapsible.component.html',
  styleUrl: './collapsible.component.scss',
  standalone: false
})
export class CoreMenuVerticalCollapsibleComponent implements OnInit, OnDestroy {
  @Input()
  public item!: CoreMenuItem;

  @HostBinding('class.open')
  public isOpen = false;

  private _unsubscribe: Subject<void>;

  constructor(
    private _router: Router,
    private _coreMenuService: CoreMenuService,
    private _changeDetectorRef: ChangeDetectorRef
  ) {
    this._unsubscribe = new Subject<void>();
  }

  ngOnInit(): void {
    this._router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntil(this._unsubscribe)
      )
      .subscribe((event: any) => {
        if (this.confirmUrlInChildren(this.item, event.urlAfterRedirects)) {
          this.expand();
        } else {
          this.collapse();
        }
      });

    this._coreMenuService.onItemCollapsed
      .pipe(takeUntil(this._unsubscribe))
      .subscribe((clickedItem) => {
        if (clickedItem && clickedItem.children) {
          if (this.confirmItemInChildren(this.item, clickedItem)) {
            return;
          }

          if (this.confirmUrlInChildren(this.item, this._router.url)) {
            return;
          }

          if (this.item !== clickedItem) {
            this.collapse();
          }
        }
      });

    if (this.confirmUrlInChildren(this.item, this._router.url)) {
      this.expand();
    } else {
      this.collapse();
    }
  }

  ngOnDestroy(): void {
    this._unsubscribe.next();
    this._unsubscribe.complete();
  }

  public toggleOpen(e: { preventDefault: () => void }): void {
    e.preventDefault();

    this.isOpen = !this.isOpen;

    this._coreMenuService.onItemCollapsed.next(this.item);
    this._coreMenuService.onItemCollapseToggled.next();
  }

  public expand(): void {
    if (this.isOpen) {
      return;
    }

    this.isOpen = true;

    this._changeDetectorRef.markForCheck();

    this._coreMenuService.onItemCollapseToggled.next();
  }

  public collapse(): void {
    if (!this.isOpen) {
      return;
    }

    this.isOpen = false;

    this._changeDetectorRef.markForCheck();

    this._coreMenuService.onItemCollapseToggled.next();
  }

  public confirmUrlInChildren(parent: CoreMenuItem, url: any): boolean {
    const children = parent.children;

    if (!children) {
      return false;
    }

    for (const child of children) {
      if (child.children) {
        if (this.confirmUrlInChildren(child, url)) {
          return true;
        }
      }

      if (child.url === url || url.includes(child.url)) {
        return true;
      }
    }

    return false;
  }

  public confirmItemInChildren(parent: CoreMenuItem, item: any): boolean {
    const children = parent.children;

    if (!children) {
      return false;
    }

    if (children.indexOf(item) > -1) {
      return true;
    }

    for (const child of children) {
      if (child.children) {
        if (this.confirmItemInChildren(child, item)) {
          return true;
        }
      }
    }

    return false;
  }
}
